<template>
  <div>
    <title-row
      title="Rendszám lekérdezés"
      :breadcrumb-items="[
        { text: 'Rendszám lekérdezés', disabled: true },
      ]" />

    <v-expansion-panels class="mb-4 rounded-xl overflow-hidden" mandatory>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="font-weight-medium">
            <v-icon left>mdi-magnify</v-icon>
            Keresés
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col :cols="4">
              <form @submit.prevent="submit">
                <v-text-field
                  v-model="searchQuery"
                  label="Rendszám"
                  dense
                  clearable
                  @click:clear="clearResults"
                  hide-details
                />
              </form>
            </v-col>
            <v-col :cols="2">
              <v-btn
                color="primary"
                rounded
                depressed
                @click="submit">Lekérdezés</v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <div v-if="isLoading" class="text-center my-4">
      <v-skeleton-loader
        class="rounded-xl"
        v-bind="attrs"
        type="article"
      ></v-skeleton-loader>
    </div>

    <div v-if="plates.length > 0">
      <h2 class="my-4">Összesített parkolás jogosultságok</h2>
      <v-row>
        <v-col cols="12" lg="6">
          <v-card  class="rounded-xl" flat>
            <v-card-text class="card-content">
              <v-chip
                v-for="area in parkingAreas"
                :key="area"
                class="ma-1"
                :color="mergedParkingAreas.includes(area) ? 'green' : 'red'"
                text-color="white"
              >
                {{ area }}
              </v-chip>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <h2 v-if="plates.length > 0" class="my-4">Kártyák ({{ plates.length }})</h2>

    <v-row>
      <v-col
        v-for="plate in plates"
        :key="plate.id"
        cols="12"
        lg="6"
      >
        <v-card class="rounded-xl" flat>
          <v-card-title>
            <div class="mr-2"><strong>Kártyaszám:</strong> {{ plate.card_number }}</div>
            <v-badge inline :color="plate.active === '1' ? 'green' : 'red'"></v-badge>
          </v-card-title>
          <v-card-text class="card-content">
            <v-row>
              <v-col cols="12" md="6">
                <div><strong>Tulajdonos:</strong> {{ plate.owner_name }}</div>
                <div><strong>Email:</strong> {{ plate.email }}</div>
                <div><strong>Rendszám:</strong> {{ plate.number }}</div>
                <div><strong>Kártya ID:</strong> {{ plate.card_id }}</div>
                <div><strong>Aktív:</strong> {{ plate.active === "1" ? 'Igen' : 'Nem' }}</div>
              </v-col>
              <v-col cols="12" md="6">
                <div><strong>Parkolási jogosultságok:</strong>
                  <div v-if="plate.parking_areas && plate.parking_areas.length > 0 && plate.active === '1'" class="chip-container">
                    <v-chip
                      v-for="area in parkingAreas"
                      :key="area"
                      class="ma-1"
                      :color="plate.parking_areas.includes(area) ? 'green' : 'red'"
                      text-color="white"
                      small
                    >
                      {{ area }}
                    </v-chip>
                  </div>
                  <div v-else>Nincs parkolási jogosultság / nem aktív a kártya</div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <div v-if="seasonTickets && seasonTickets.length > 0">
      <h2 class="my-4">Bérletek ({{ seasonTickets.length }})</h2>
      <v-row>
        <v-col
          v-for="ticket in seasonTickets"
          :key="ticket.id"
          class=" rounded-xl"
          cols="12"
          lg="6"
        >
          <v-card class="rounded-xl">
            <v-card-title>
              <div><strong>Bérlet ID:</strong> {{ ticket.id }}</div>
            </v-card-title>
            <v-card-text >
              <v-row>
                <v-col cols="12" md="6">
                  <div><strong>Kártyaszám:</strong> {{ ticket.card_number }}</div>
                  <div><strong>Érvényesség kezdete:</strong> {{ new Date(ticket.validation_date).toLocaleDateString()}}</div>
                  <div><strong>Érvényesség vége:</strong> {{ new Date(ticket.validity_end).toLocaleDateString()}}</div>
                </v-col>
                <v-col cols="12" md="6">
                  <div><strong>Parkolási jogosultságok:</strong>
                    <div v-if="seasonTicketParkingAreas(ticket).length > 0" class="chip-container">
                      <v-chip
                        v-for="area in parkingAreas"
                        :key="area"
                        class="ma-1"
                        :color="seasonTicketParkingAreas(ticket).includes(area) ? 'green' : 'red'"
                        text-color="white"
                        small
                      >
                        {{ area }}
                      </v-chip>
                    </div>
                    <div v-else>Nincs parkolási jogosultság</div>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <div v-if="barcodes && barcodes.length > 0">
        <h2 class="my-4">Vonalkódok ({{ barcodes.length }})</h2>
        <v-row>
          <v-col
            v-for="barcode in barcodes"
            :key="barcode.id"
            class=" rounded-xl"
            cols="12"
            xs="12"
            sm="6"
            lg="2"
          >
            <v-card class="rounded-xl">
              <v-card-title>
                <div><strong>Vonalkód:</strong> {{ barcode.barcode_number }}</div>
              </v-card-title>
              <v-card-text >
                <div><strong>Email:</strong> {{ barcode.email }}</div>
                <div><strong>RFID:</strong> {{ barcode.rf_id }}</div>
                <div><strong>Hozzárendelve:</strong> {{ barcode.start_date_time ? new Date(barcode.start_date_time).toLocaleString() : 'Null érték' }}</div>
                <div><strong>Lejárat:</strong> {{ barcode.end_date ? new Date(barcode.end_date).toLocaleString() : 'Nincs' }}</div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlateSearch',
  data(){
    return {
      searchQuery: '',
      isLoading: false,
      plates: [],
      barcodes: [],
      seasonTickets: [],
      mergedParkingAreas: [],
      parkingAreas: ["P1", "P2", "P3", "P4", "P5", "P6", "P7", "P8", "P9", "P10", "P11", "P12", "P13", "P14"]
    }
  },

   methods: {
    async fetchLicensePlate() {
      try {
        if (this.searchQuery.length < 3) {
          this.$dialog.notify.error('A keresési kifejezésnek legalább 3 karakter hosszúnak kell lennie.');
          return;
        } else {
          this.isLoading = true;
          const response = await this.$http.get(`/plate/search/${this.searchQuery}`);
          this.seasonTickets = response.seasonTickets?.season_tickets;
          this.plates = response.plates;
          this.barcodes = response.barcodes;
          this.mergedParkingAreas = this.mergeParkingAreas(this.plates);
        }
      } catch (error) {
        this.$toast.error('Hiba történt a keresés során.');
        this.plates = [];
        this.isLoading = false;
        return;
      } finally {
        this.isLoading = false;
      }
    },
    seasonTicketParkingAreas(ticket) {
      const matchingPlate = this.plates.find(plate => Number(plate.card_number) === ticket.card_number);
      return matchingPlate ? matchingPlate.parking_areas : [];
    },
    mergeParkingAreas(plates) {
      const allAreas = new Set();
      plates.forEach(plate => {
        if (plate.parking_areas && plate.parking_areas.length > 0) {
          plate.parking_areas.forEach(area => allAreas.add(area));
        }
      });

      return Array.from(allAreas);
    },
    submit(event){
      event.preventDefault()
      this.fetchLicensePlate();
    },
     clearResults() {
      this.plates = [];
      this.barcodes = [];
      this.seasonTickets = [];
      this.mergedParkingAreas = [];
    }
   },

   watch: {
    searchQuery(newQuery) {
      if (newQuery === '') {
        this.clearResults();
      }
    }
   }
}
</script>